<div *ngIf="navData" fxLayoutGap="10px" class="data-wrap pt-0" fxLayout="column">
    <div class="title mt-0" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon class="title-icon dark-blue {{ navData.data.class }}">{{ navData.data.icon }}</mat-icon>
        <div class="title-label dark-blue {{ navData.data.class }}" fxFlex="grow">{{ navData.data.title }}</div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <app-image-view
            [ngStyle]="{ minWidth: '110px' }"
            [media_id]="navData.data.resource.media"
            paddingBottom="70px"
        ></app-image-view>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span class="dark-blue res-title">{{ navData.data.resource.title }}</span>
        </div>
    </div>
    <ng-container *ngIf="!!navData.data.descs?.length">
        <ng-container *ngFor="let desc of navData.data.descs">
            <div [innerHTML]="desc | innerHtml : 'tool_desc'" *ngIf="!!desc" class="excludes-hint"></div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="navData.data.actions?.length" [ngTemplateOutlet]="actions"></ng-container>
    <div
        *ngIf="!navData.data.actions?.length"
        class="action"
        fxLayout="row-reverse"
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
    >
        <button fxFlex="0 0 auto" class="mobile-button positive" (click)="onClose.emit(null)" mat-button i18n>
            Done
        </button>
    </div>
</div>

<ng-template #actions>
    <div class="action" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
        <ng-container *ngFor="let action of navData.data.actions">
            <button
                fxFlex="0 0 auto"
                class="mobile-button positive {{ action.class }}"
                [attr.data-testid]="action.value ? 'resource-play-confirm' : 'resource-play-cancel'"
                (click)="
                    onClose.emit(
                        action.value
                            ? {
                                  action: SideNaveActionsTypes.POSITIVE,
                                  data: {
                                      type: navData.data.type,
                                      response: action.value,
                                      value: message.value,
                                      selectedOccasionId: selectedOccasionId.value
                                  }
                              }
                            : null
                    )
                "
                mat-button
                i18n
            >
                {{ action.label }}
            </button>
        </ng-container>
    </div>
</ng-template>
